import * as apicall from "../components/Apicall";

const qs = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const search = new URLSearchParams(clean).toString();
  return search ? `?${search}` : "";
};

/* ---------------------------------------------------------------- *
 *  Branches (Settings)
 * ---------------------------------------------------------------- */
export const getCenters = (filters = {}) => apicall.get(`expense-management/centers${qs(filters)}`);
export const createCenter = (data) => apicall.post(data, "expense-management/centers");
export const updateCenter = (id, data) => apicall.post(data, `expense-management/centers/${id}`);
export const setCenterStatus = (id, status) => apicall.post({ status }, `expense-management/centers/${id}/status`);

/* ---------------------------------------------------------------- *
 *  Expense entries
 * ---------------------------------------------------------------- */
export const checkDuplicates = (data) => apicall.post(data, "expense-management/entries/check-duplicates");
export const uploadEntries = (data) => apicall.post(data, "expense-management/entries/upload");
export const getEntries = (filters = {}) => apicall.get(`expense-management/entries${qs(filters)}`);
// Every entry id matching filters (not just the current page), plus aggregate
// totals and how many are still invoiceable - powers "select all N matching".
export const getEntryIds = (filters = {}) => apicall.get(`expense-management/entries/ids${qs(filters)}`);
export const updateEntry = (id, data) => apicall.post(data, `expense-management/entries/${id}`);
export const deleteEntry = (id) => apicall.del(`expense-management/entries/${id}`);
// Soft-deletes many entries; invoiced ones are skipped. data.data is { deleted, skipped }.
export const bulkDeleteEntries = (ids) => apicall.post({ ids }, "expense-management/entries/bulk-delete");

/* ---------------------------------------------------------------- *
 *  Customers (invoice Bill To): individuals (ezp_customers) + companies
 * ---------------------------------------------------------------- */
export const searchCustomers = (q) => apicall.get(`expense-management/customers/search${qs({ q })}`);
// data: { type, name, phone_number?, email?, address?, trn? } -> data.data is the
// customer ({ type, id, name, phone, email, trn, address, existing }).
export const createCustomer = (data) => apicall.post(data, "expense-management/customers");

/* ---------------------------------------------------------------- *
 *  Invoices
 * ---------------------------------------------------------------- */
// Streams the PDF back and downloads it (apicall.generate_pdf); rejects with
// "Server error: <status> - <body>" on failure - see errorMessage() below.
// customer is the Bill To: { type: "INDIVIDUAL" | "COMPANY", id }. invoiceDate is
// 'YYYY-MM-DD' (past or future allowed); omitted = the server's current date.
export const generateInvoice = (entryIds, uploadBatchId, customer, invoiceDate) =>
  apicall.generate_pdf(
    {
      entry_ids: entryIds,
      ...(invoiceDate ? { invoice_date: invoiceDate } : {}),
      ...(uploadBatchId ? { upload_batch_id: uploadBatchId } : {}),
      customer: { type: customer?.type, id: customer?.id },
    },
    "expense-management/invoices/generate"
  );
export const getInvoices = (filters = {}) => apicall.get(`expense-management/invoices${qs(filters)}`);
export const getInvoice = (id) => apicall.get(`expense-management/invoices/${id}`);
// Cancel: the invoice and every job on it (so the dialog can warn about jobs outside the
// selection), then the VOID itself - which releases all of them. reason is required.
export const getInvoiceImpact = (id) => apicall.get(`expense-management/invoices/${id}/impact`);
export const cancelInvoice = (id, reason) =>
  apicall.post({ reason }, `expense-management/invoices/${id}/cancel`);

/* ---------------------------------------------------------------- *
 *  Error text helpers
 * ---------------------------------------------------------------- */
// apicall.post resolves with { success:false, message } (or express-validator's
// { errors:[{msg}] }) instead of throwing.
export const responseMessage = (res, fallback = "Something went wrong") =>
  res?.message || res?.errors?.[0]?.msg || fallback;

// Pulls the API's own message out of generate_pdf's "Server error: 409 - {json}".
export const errorMessage = (err, fallback = "Something went wrong") => {
  const raw = String(err?.message || err || "");
  const match = raw.match(/- (\{.*\})\s*$/s);
  if (match) {
    try {
      const body = JSON.parse(match[1]);
      return body.message || body.errors?.[0]?.msg || fallback;
    } catch {
      /* fall through */
    }
  }
  return raw || fallback;
};
